import { defineStore } from 'pinia'

export interface QuickLinkOption {
  label: LangString
  toLink: (keyword: string) => string
}

export const useQuickLinkStore = defineStore('quick-link', () => {
  const _quickLinkOptions: Ref<QuickLinkOption[]> = ref([])
  const quickLinkOptions = computed({
    get: () => _quickLinkOptions.value,
    set: v => _quickLinkOptions.value = v
  })

  const _showQuickLink: Ref<boolean> = ref(false)
  const showQuickLink = computed({
    get: () => _showQuickLink.value,
    set: v => _showQuickLink.value = v
  })

  const clearQuickLink = () => {
    showQuickLink.value = false
    quickLinkOptions.value = []
  }

  return {
    quickLinkOptions,
    showQuickLink,
    clearQuickLink,
  }
})
